import { createSlice } from "@reduxjs/toolkit";

const initialStateValues = {
  // fetchDeviceDetails: {
  //   loading: false,
  //   success: false,
  //   error: false,
  //   deviceDetails: {}
  // },
  // fetchDevicePolicies: {
  //   loading: false,
  //   success: false,
  //   error: false,
  //   devicePolicies: []
  // }
}
const mdmDeviceStateSlice = createSlice({
  name: "mdmDevice/state",
  initialState: initialStateValues,
  reducers: {
    // resetFetchDeviceDetails: (state) => {
    //   state.fetchDeviceDetails = initialStateValues.fetchDeviceDetails
    // },
    // resetFetchDevicePoliciesState: (state) => {
    //   state.fetchDevicePolicies = initialStateValues.fetchDevicePolicies
    // }
  },
});

export const {
  // resetFetchDeviceDetails,
  // resetFetchDevicePoliciesState
} =
  mdmDeviceStateSlice.actions;

export default mdmDeviceStateSlice.reducer;
